module.exports = __webpack_public_path__ + "static/Lato-Medium-06e1c8dbe641dd9dfa4367dc2a6efb9f.ttf";